import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useImportDonationsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IImportDonationPreview) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ file, impersonationContext }: { file: File; impersonationContext?: Api.IImpersonationContext }) => {
			const data = new FormData();
			data.append('file', file);

			return userSession.webServiceHelper.callAsync<Api.IImportDonationPreview>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `donation/importFromFile`,
				}),
				'POST',
				data
			);
		},
		onError,
		onSuccess,
	});
};
